export default "__VITE_ASSET__D$DAEp$v__"